export const REBRAND_RESOURCE_SRC = {
  DESKTOP:
    'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/mp-logo-animation-desktop-gif-loop--d2910e1a.gif',
  MOBILE:
    'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/mp-logo-animation-mobile-gif-loop--cdc611e5.gif',
};
